export type ThemeId = 'luna-blue' | 'luna-olive' | 'luna-silver';

export interface Theme {
  id: ThemeId;
  name: string;
  /** Value written to `<html data-theme>`; the CSS vars live in `themes.css`. */
  available: boolean;
}

export const themes: Theme[] = [
  { id: 'luna-blue', name: 'Windows XP (Luna Blue)', available: true },
  { id: 'luna-olive', name: 'Windows XP (Olive Green)', available: true },
  { id: 'luna-silver', name: 'Windows XP (Silver)', available: true },
];

export const DEFAULT_THEME: ThemeId = 'luna-blue';

export function findTheme(id: string): Theme {
  return themes.find((t) => t.id === id) ?? themes[0]!;
}
